import { Integer } from 'app/shared/domain/value-objects/integer';

export class MaintenancePageOrigin extends Integer {

}
